(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-policy-list"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', (event) => {
  const link = event.target.closest('a[href="#shopifyReshowConsentBanner"]');
  if (link && window.privacyBanner?.showPreferences) {
    event.preventDefault();
    window.privacyBanner.showPreferences();
  }
});
  } catch(e) { console.error(e); }
})();

})();
